import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const PlusIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
    >
        <path
            fill="currentColor"
            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm0 14.48c-3.56 0-6.48-2.88-6.48-6.48C1.52 4.44 4.4 1.52 8 1.52c3.6 0 6.48 2.92 6.48 6.48 0 3.56-2.92 6.48-6.48 6.48Zm2.8-7.28h-2v-2c0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8v2h-2c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h2v2c0 .44.36.8.8.8.44 0 .8-.36.8-.8v-2h2c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8Z"
        />
    </svg>
);